
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies-thank-you",
      function () {
        return require("private-next-pages/case-studies-thank-you.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-studies-thank-you"])
      });
    }
  